import { RadioGroup as RadioGroupComponent } from "../../RadioGroup";
import { RadioGroupProps } from "../types";
import { withFormField } from "./withFormField";

export const RadioGroup = withFormField<RadioGroupProps>(RadioGroupComponent);
